import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { CloseOutlined, DeleteOutline } from "@mui/icons-material";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import PassengerApi from "Services/Passenger";

const ServiceDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profileimage, setProfileImage] = useState(null);
  const [username, setUsername] = useState(null);

  const getDetails = useCallback(() => {
    if (!id) return;
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setProfileImage(res.data.data.image);
        setUsername(res.data.data.firstName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    PassengerApi.getPassengerDetails(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleDeleteServicetype = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Passenger Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting passenger",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    PassengerApi.deletePassenger(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      {/* Header */}
      <Box className={classes.dialogHeader}>
        <Typography className={classes.dialogHeaderTitle}>Delete Passenger</Typography>
        <IconButton className={classes.closeIconBtn} onClick={handleClose}>
          <CloseOutlined />
        </IconButton>
      </Box>

      {/* Body */}
      <Box className={classes.dialogBody}>
        <Box className={classes.avatarWrapper}>
          <img
            src={profileimage || "/assets/images/passingeroruserimg.png"}
            alt="Passenger"
            className={classes.avatarImg}
          />
          <Typography className={classes.nameText}>{username || "This passenger"}</Typography>
        </Box>
        <Typography className={classes.descriptionText}>
          Are you sure you want to delete <strong>{username || "this passenger"}</strong>? This action cannot be undone and all associated data will be permanently removed.
        </Typography>
      </Box>

      {/* Footer */}
      <Box className={classes.dialogFooter}>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={classes.deleteButton}
          onClick={handleDeleteServicetype}
          startIcon={<DeleteOutline />}
        >
          Delete Passenger
        </Button>
      </Box>
    </Dialog>
  );
};

export default ServiceDelete;
